export default "__VITE_ASSET__FjgEFXJu__"